import React from "react";
import StopTwoToneIcon from "@mui/icons-material/StopTwoTone";
import { Button, Tooltip } from "@mui/material";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function CustomizedDialogs(props) {
  let { tag, endDate, endTime, startDate, startTime, dependson, labType } = props;
  
  function DateTime2(endDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate).toLocaleString("en-GB", {
      timeZone: timezone,
    });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace(/\//g, "-");
    const endDate3 = endDatef.replace(/\//g, "-");
    return endDate3;
  }

  function timeDiff(endDate, endTime, startDate, start_time, dependson) {

    function parseDate(str) {
      const [day, month, year] = str.split("-");
      return new Date(year, month - 1, day); // month is 0-based
    }
    
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    const currentTime = new Date().toLocaleString('en-GB', { timeZone: `${timezone}` });
    const currentTime1 = currentTime.split(",");
    const formattedTime = currentTime1[1].substring(0, 6);
    const endTimeMoment = moment(endTime3, 'HH:mm');
    const formattedTimeMoment = moment(formattedTime, 'HH:mm');
    
    let disableButton = true;
    const diffInMinutes = endTimeMoment.diff(formattedTimeMoment, 'minutes');

    // const labEndDate = moment(endDate).format("DD-MM-YYYY");
    // var currentDate = new Date().toISOString().substring(0, 10);

    const now = new Date();
    const currentDate_now = moment(now).format('DD-MM-YYYY');
    // const CurrentTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

    const startUTC = new Date(startDate + "T" + start_time + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startDate2 = startUTC.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-"); // get the lab Start Date part only
    // const startTime2 = startUTC.split(",");
    // const startTimeStr = startTime2[1].substring(0, 6); // get the start time part only

    const endUTC = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endDate2 = endUTC.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-"); // get the end Date part only
    // const endTime42 = endUTC.split(",");
    // const endTimeStr = endTime42[1].substring(0, 6); // get lab Stop time part only

    // get parsing Dates
    const startDate_parse = parseDate(startDate3); // get parsing lab start date
    const endDate_parse = parseDate(endDate3); // get parsing lab end date
    const currentDate_parse = parseDate(currentDate_now); // get parsing current date

    const isWithinDateRange = currentDate_parse >= startDate_parse && currentDate_parse <= endDate_parse;
    const env_diffMinutes = (process.env.REACT_APP_DIFFENDTIME || 0); // REACT_APP_DIFFENDTIME
    // console.log("process.env.REACT_APP_DIFFENDTIME", diffMinutes);
    // let disableButton = false;

    if (dependson === "immediate" || dependson === "always") {
      // Check if within allowed time before end
      console.log("step-1");
      const endUtc = new Date(`${endDate}T${endTime}:00Z`);
      const totalMinutesRemaining = Math.floor((endUtc - now) / (1000 * 60));
      // console.log("diffMinutes - totalMinutesRemaining", totalMinutesRemaining);
      // console.log("isWithinDateRange", isWithinDateRange);
      
      if (isWithinDateRange) {
        // console.log("diffMinutes inside total min", totalMinutesRemaining);
        
        if (totalMinutesRemaining > env_diffMinutes) {
          disableButton = false;
        }
      }
    }
    else {
      disableButton = diffInMinutes <= env_diffMinutes && diffInMinutes >= 0;
    }

    // console.log("difference_minutes", `${process.env.REACT_APP_DIFFENDTIME}`)
    // console.log("diffInMinutes", diffInMinutes);
    // console.log("disableButton button status", disableButton);
    return disableButton;
  }

  const [open, setOpen] = React.useState(false);
  const [popupopen, setPopUpOpen] = React.useState(false);
  const [opentitle, setOpentitle] = React.useState();
  const [popupopentitle, setPopupOpentitle] = React.useState("Are you sure you want to stop a lab?.");

  const handleClose = () => {
    setOpen(false);
    setPopUpOpen(false);
  };

  const handlePopUpClose = () => {
    setPopUpOpen(false);
  };

  const handleOpen = () => {
    setPopUpOpen(true);
  };

  const handleSubmitClick = (e) => {
    // console.log(tag);
    e.preventDefault();
    // window.location.reload();
    const InstanceID = localStorage.getItem("InstanceID");
    let api_call = ""
    if (labType === "custom") {
      api_call = `${process.env.REACT_APP_API_URL}/api/individualstopcustomlab/${InstanceID}/${tag}`
    }
    else if (labType === "hvm") {
      api_call = `${process.env.REACT_APP_API_URL}/api/individualstophvmlab/${InstanceID}/${tag}`
    }
    else if (labType === "wise") {
      api_call = `${process.env.REACT_APP_API_URL}/api/individualstopwiselab/${InstanceID}/${tag}`
    }
    
    fetch(api_call, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          if (data === "Success") {
            setOpen(false);
            window.location.reload();
          }
          else {
            setOpen(true);
            setOpentitle(data);
          }
        } else {
          if (data.name) {
            setOpen(false);
            setState({ errorMessage: data.name[0] });
          }
        }
      })
      .catch((error) => {
        setOpen(false);
        window.location.reload();
      });
  };

  return (
    <div>
       <Dialog
          open={popupopen}
          onClose={handlePopUpClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {popupopentitle} {" "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handlePopUpClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSubmitClick} color="primary">
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {opentitle} {" "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      <Tooltip title="Stop" arrow>
        <span>
      <Button
        sx={{ 
          mx: 1,
          width: { xs: '75px', sm: '85px' },
          height: { xs: '23px', sm: '25px' },
          borderRadius: '50px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
        }}
        variant="contained"
        startIcon={<StopTwoToneIcon sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }} />}
        disabled={ timeDiff(endDate, endTime, startDate, startTime, dependson, labType) }
        onClick={handleOpen}
        aria-label="Stop"
      >
        Stop
      </Button>
        </span>
      </Tooltip>
    </div>
  );
}
